import { controls } from "../../controls"

const ms216 = {
  label: "Account Minimum Balance",
  pageLabel: "Account Minimum Balance",
  starting: true,
  url: "ms216",
  pageType: "history",
  formActions: { edit: { allow: true } },
  formTabs: {
    allTabs: [

      {
        label: "Create",
        uid: "create",
        style: { fontFamily: "verdana" }
      }
    ]
  },
  filter: [

    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", widths: "col-sm-2" }),
    ...controls.branch({ tab: "filter", isRequired: true, defaultValue: "assigned_branch" }),

    ...controls.showData({ tab: "filter", data: "branch_display", isRequired: true, name: "branch_display", }),

    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", star: true, label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", isRequired: true, width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "product_code_display", name: "product_code_display" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4" }),


    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),


    ...controls.displayText({ tab: "filter", label: "Account No", width: "col-sm-2" }),
    ...controls.AccountNumber({
      tab: "filter", beforeLeave: ["createAcNo"],
    }),
    ...controls.showData({ tab: "filter", data: "account_number_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", label: "Customer Type", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", width: "col-sm-2", options: [
        {
          label: "individual",
          value: "individual"
        },
        {
          label: "internal",
          value: "internal"
        },
        {
          label: "Other",
          value: "other"
        }
      ], name: "customer_type"
    }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", isRequired: true, star: true, default: true, label: "Active", name: "isActive", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-3" }),

    ...controls.displayText({ tab: "filter", label: "Customer Number", width: "col-sm-2" }),
    ...controls.customerNumber({ tab: "filter", onChangeSet: { customer_changed: true } }),
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    ...controls.displayText({ tab: "filter", label: "Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", placeHolder: "Enter Name", name: "customer_number_display", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", label: "Number Of Records", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "per_page", placeHolder: "Enter Number Of Records", width: "col-sm-2" }),


  ],
  form: [
    ...controls.displayText({ tab: "create", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: 'create', isReadOnly: 'edit', isRequired: true, defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "create", data: "branch_display", name: "branch_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-5" }),

    ...controls.displayText({ tab: "create", star: true, label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: 'create', isReadOnly: 'edit', isRequired: true, }),
    ...controls.showData({ tab: "create", data: "product_code_display", name: "product_code_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-6" }),
    ...controls.displayText({ tab: "create", label: "Account No", width: "col-sm-2" }),
    ...controls.AccountNumber({
      tab: "create", beforeLeave: ["createAcNo"],
    }),
    ...controls.showData({ tab: "create", data: "account_number_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-6" }),
    ...controls.magicDateLabel({ tab: "create", star: true, label: "Date", width: "col-sm-2" }),
    ...controls.magicDate({
      isRequired: true, tab: "create", dateType: "ontype", name: "open_date",
      width: "col-sm-2", default: "sessiondate"
    }),
    ...controls.displayText({ tab: "create", width: "col-sm-8" }),
    ...controls.displayText({ style: { textAlign: 'right' }, tab: "create", label: "Minimum Balance", width: "col-sm-2" }),
    ...controls.numtoword({
      tab: "create", convertedTo: "min_bal_text", name: "min_balance", width: "col-sm-2",
    }),
    ...controls.showData({
      tab: "create", data: "min_bal_text", name: "min_bal_text", width: "col-sm-6", style: { fontSize: 14 },
    }),
    ...controls.displayText({ tab: "create", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", label: "Remark", width: "col-sm-2" }),
    ...controls.text({ tab: "create", name: "remark", width: "col-sm-2", placeHolder: "Remark" }),

    ...controls.checkBox({ tab: "create", isRequired: true, star: true, default: true, label: "Active", name: "isActive", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-3" }),
  ],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Branch",
        accessor: "branch_display_name",
        width: 150
      },
      {
        Header: "CIN",
        accessor: "customer_number",
        width: 150
      },
      {
        Header: "A/c No",
        accessor: "account_number"
      },
      {
        Header: "Name",
        accessor: "descn"
      },
      {
        Header: "Amount",
        accessor: "min_bal"
      },
      {
        Header: "As On Date",
        accessor: "as_on_date"
      },
      {
        Header: "Modified By",
        accessor: "entryby"
      },
      {
        Header: "Modified Date",
        accessor: "entrydate"
      },
      {
        Header: "Modified time",
        accessor: "entrytime"
      }, {
        Header: "Active",
        accessor: "isActive",
        type: "tick"
      }
    ]
  }
};

export default ms216;
